<template>
  <div>
    <b-row>
      <b-col xxs="12">
        <h3>{{ $t("SMS Ayarları") }}</h3>
        <div class="mb-4"></div>
      </b-col>
    </b-row>
    <b-row v-if="loaded">
      <b-col>
        <b-form-group :label="$t('Servis Sağlayıcı')">
            <b-form-select v-model="settings.provider" :options="serviceProviders" @change="refreshData" />
        </b-form-group>
        <b-form-group :label="$t('SMS Başlığı')">
          <b-form-input v-model="settings.title"></b-form-input>
        </b-form-group>

        <template v-if="settings.provider && settings.provider === 'bulutfon'">
          <b-form-group :label="$t('API Key')">
            <b-form-input v-model="settings.api_key"></b-form-input>
          </b-form-group>
          <b-row>
            <b-col>
              <p>{{ $t("Bulutfon panelinde Ayarlar > API Kullanıcıları bölümünden bir kullanıcı oluşturup API Key'i giriniz.") }}</p>
            </b-col>
          </b-row>
        </template>

        <template v-else-if="settings.provider && settings.provider === 'netgsm'">
          <b-row>
            <b-col>
              <b-form-group :label="$t('Kullanıcı Adı')">
                <b-form-input v-model="settings.username"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group :label="$t('Şifre')">
                <b-form-input v-model="settings.password"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p>{{ $t("NetGSM paneline girişte kullandığınız kullanıcı adı ve şifrenizi giriniz.") }}</p>
            </b-col>
          </b-row>
        </template>

        <template v-else-if="settings.provider && settings.provider === 'iletimerkezi'">
          <b-row>
            <b-col>
              <b-form-group :label="$t('API Key')">
                <b-form-input v-model="settings.api_key"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group :label="$t('Secret (Gizli Şifre)')">
                <b-form-input v-model="settings.api_secret"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p>{{ $t("IletiMerkezi panelinden Ayarlar bölümünden aldığınız API bilgilerini giriniz.") }}</p>
            </b-col>
          </b-row>
        </template>

        <template v-else-if="settings.provider && settings.provider === 'jetsms'">
          <b-row>
            <b-col>
              <b-form-group :label="$t('Kullanıcı Adı')">
                <b-form-input v-model="settings.username"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group :label="$t('Şifre')">
                <b-form-input v-model="settings.password"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p>{{ $t("JetSMS paneline girişte kullandığınız kullanıcı adı ve şifrenizi giriniz.") }}</p>
            </b-col>
          </b-row>
        </template>

        <template v-else-if="settings.provider && settings.provider === 'smsvitrini'">
          <b-row>
            <b-col>
              <b-form-group :label="$t('Kullanıcı Adı')">
                <b-form-input v-model="settings.username"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group :label="$t('Şifre')">
                <b-form-input v-model="settings.password"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p>{{ $t("SMSVitrini paneline girişte kullandığınız kullanıcı adı ve şifrenizi giriniz.") }}</p>
            </b-col>
          </b-row>
        </template>

        <template v-else-if="settings.provider && settings.provider === 'organik'">
          <b-row>
            <b-col>
              <b-form-group :label="$t('API Key')">
                <b-form-input v-model="settings.api_key"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p>{{ $t("OrganikSMS panelinden oluşturduğunuz API kullanıcısına ait API Key'i giriniz.") }}</p>
            </b-col>
          </b-row>
        </template>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col class="text-center">
        <b-spinner></b-spinner>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-right">
        <b-button @click.prevent="submit" variant="primary">{{ $t("Ayarları Kaydet") }}</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapActions, mapMutations } from 'vuex';
  export default {
    name: 'SMSSettings',
    data(){
      return {
        loaded: false,
        settings: {},
        serviceProviders: [
          { value: 'netgsm', text: 'NetGSM' },
          { value: 'iletimerkezi', text: 'İleti Merkezi' },
          { value: 'bulutfon', text: 'Bulutfon' },
          { value: 'organik', text: 'Organik SMS' },
          // { value: 'jetsms', text: 'JetSMS' },
          // { value: 'smsvitrini', text: 'SMS Vitrini' },
        ],
      }
    },
    methods: {
      ...mapActions(['getSMSSettings', 'updateSMSSettings']),
      ...mapMutations(['setSMSBalance']),
      refreshData(newValue) {
        this.settings = {
          provider: newValue,
        }
      },
      submit(){
        this.updateSMSSettings({
          payload: this.settings
        }).then(response => {
          this.success(response.data.message);
          this.setSMSBalance(response.data.balance);
        }).catch(error => {
          this.error(error.response.data.message);
        });
      },
    },
    mounted() {
      this.loaded = false;
      this.getSMSSettings().then(response => {
        if( !response.data ) {
          this.settings = {
            provider: 'organik',
          }
        } else {
          this.settings = response.data;
        }
        this.loaded = true;
      })
    }
  }
</script>
